import React, { useState, useEffect, useRef, useCallback } from "react";
import "./GeodesyCoordinateConverter.css";
import { getAuthHeaders, fetchWithAuth } from '../../utils/auth';
import { sanitizeError } from '../../utils/errorMessages';

/* ─── Icônes inline (pas de dépendance supplémentaire) ─────────────────────── */
const Icon = {
  ArrowRight: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  ),
  Globe: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  Zap: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  Upload: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
  CheckCircle: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  AlertCircle: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  ChevronDown: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  RotateCcw: ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>
    </svg>
  ),
  Copy: ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
  ),
  MapPin: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  BarChart: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  X: ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  File: ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/>
    </svg>
  ),
  Download: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  ),
  Info: ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
    </svg>
  ),
  Target: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
    </svg>
  ),
  Function: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M15 3h4a2 2 0 0 1 2 2v3M15 21h4a2 2 0 0 0 2-2v-3M3 9V5a2 2 0 0 1 2-2h3M3 15v4a2 2 0 0 0 2 2h3"/>
      <path d="M7 12h10M12 7v10"/>
    </svg>
  ),
  Layers: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>
    </svg>
  ),
  GitCompare: ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/>
      <path d="M13 6h3a2 2 0 0 1 2 2v7"/><path d="M11 18H8a2 2 0 0 1-2-2V9"/>
      <polyline points="15 9 18 6 21 9"/><polyline points="9 15 6 18 3 15"/>
    </svg>
  ),
};

/* ─── Constantes métier (INCHANGÉES) ───────────────────────────────────────── */
const URLS_BASE = `${process.env.REACT_APP_API_URL}/api/v1`;

const getCookie = (name) => {
  if (name === "csrftoken")
    return document.cookie.split("; ").find((r) => r.startsWith("csrftoken="))?.split("=")[1] || "";
  return null;
};

const SYSTEMS = [
  { key: "wgs84",   label: "WGS84",   sub: "Lat / Lon",      color: "#3b82f6" },
  { key: "utm",     label: "UTM",     sub: "Est / Nord",     color: "#8b5cf6" },
  { key: "laborde", label: "Laborde", sub: "X / Y",          color: "#10b981" },
];

const CALC_METHODS = [
  {
    key: 'moindres_carres',
    label: 'Moindres carrés',
    short: 'MC',
    description: 'Itératif non-linéaire, le plus robuste',
    color: '#6366f1',
    Icon: () => <Icon.Target size={14} />,
  },
  {
    key: 'bursa_wolf',
    label: 'Bursa-Wolf',
    short: 'BW',
    description: 'Analytique linéarisé, standard IGN',
    color: '#0ea5e9',
    Icon: () => <Icon.Function size={14} />,
  },
  {
    key: 'molodensky_badekas',
    label: 'Molodensky-Badekas',
    short: 'MB',
    description: 'Rotation autour du centroïde local',
    color: '#10b981',
    Icon: () => <Icon.Layers size={14} />,
  },
];

const SYSTEM_FIELDS = {
  wgs84:   [{ name: "latitude",  label: "Latitude",   unit: "°" }, { name: "longitude", label: "Longitude",  unit: "°" }],
  utm:     [{ name: "zone",      label: "Zone UTM",   unit: "" },  { name: "easting",   label: "Easting (E)", unit: "m" }, { name: "northing", label: "Northing (N)", unit: "m" }],
  laborde: [{ name: "x",        label: "X",          unit: "m" }, { name: "y",         label: "Y",          unit: "m" }],
};

/* ─── Guides format fichier (issus des fichiers Data_test/Transformation) ────── */
const FORMAT_GUIDES = {
  wgs84: {
    label: 'WGS 84 / GPS',
    color: '#3b82f6',
    description: 'Coordonnées géographiques en degrés décimaux.',
    columns: [
      { name: 'id',        desc: 'Identifiant du point (numérique ou texte)' },
      { name: 'latitude',  desc: 'Latitude décimale — négatif = hémisphère Sud' },
      { name: 'longitude', desc: 'Longitude décimale — positif = Est de Greenwich' },
    ],
    example: [
      '0;-18.91552;47.52166',
      '1;-18.60004;47.34787',
      '2;-18.60008;47.34814',
    ],
    tips: [
      'Séparateur obligatoire : point-virgule  ;',
      'Madagascar : latitude ≈ −12 à −26,  longitude ≈ 43 à 51',
      'Pas de ligne d\'en-tête — données directement à la 1ère ligne',
    ],
  },
  utm: {
    label: 'UTM',
    color: '#8b5cf6',
    description: 'Coordonnées projetées UTM en mètres. La zone (38 ou 39) sera demandée au moment du calcul.',
    columns: [
      { name: 'id',       desc: 'Identifiant du point' },
      { name: 'E (Est)',  desc: 'Abscisse Est en mètres' },
      { name: 'N (Nord)', desc: 'Ordonnée Nord en mètres' },
    ],
    example: [
      '0;767095.363;7897341.587',
      '1;747753.066;7941805.562',
      '2;747781.513;7941800.782',
    ],
    tips: [
      'Séparateur obligatoire : point-virgule  ;',
      'Zone 38 S → côte Ouest  (E ≈ 350 000 – 800 000 m)',
      'Zone 39 S → côte Est    (E ≈ 160 000 – 600 000 m)',
    ],
  },
  laborde: {
    label: 'Laborde Madagascar',
    color: '#10b981',
    description: 'Système national Laborde — projection conique oblique de Madagascar, valeurs en mètres.',
    columns: [
      { name: 'id', desc: 'Identifiant du point' },
      { name: 'X',  desc: 'Coordonnée X (axe horizontal, en mètres)' },
      { name: 'Y',  desc: 'Coordonnée Y (axe vertical, en mètres)' },
    ],
    example: [
      '0;515775.065;788819.201',
      '1;496086.386;833090.576',
      '2;496114.848;833086.029',
    ],
    tips: [
      'Séparateur obligatoire : point-virgule  ;',
      'Plages typiques : X ≈ 400 000 – 700 000 m  ·  Y ≈ 700 000 – 1 000 000 m',
      'Format identique aux exports de logiciels topographiques malgaches',
    ],
  },
};

/* ─── Modal guide format ─────────────────────────────────────────────────────── */
const FormatGuideModal = ({ system, onClose }) => {
  // useEffect AVANT le return conditionnel (règle des hooks)
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const guide = FORMAT_GUIDES[system];
  if (!guide) return null;

  return (
    <div className="gcc-guide-backdrop" onClick={onClose}>
      <div className="gcc-guide-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">

        {/* Header */}
        <div className="gcc-guide-header">
          <div className="gcc-guide-title">
            <span className="gcc-guide-dot" style={{ background: guide.color }} />
            Format fichier — <strong>{guide.label}</strong>
          </div>
          <button className="gcc-guide-close" onClick={onClose} aria-label="Fermer">
            <Icon.X size={14} />
          </button>
        </div>

        <div className="gcc-guide-body">

          {/* Description */}
          <p className="gcc-guide-desc">{guide.description}</p>

          {/* Colonnes */}
          <div className="gcc-guide-section">Colonnes (dans l'ordre)</div>
          <div className="gcc-guide-cols">
            {guide.columns.map((col, i) => (
              <div key={i} className="gcc-guide-col">
                <span className="gcc-guide-col-name" style={{ color: guide.color }}>{col.name}</span>
                <span className="gcc-guide-col-desc">{col.desc}</span>
              </div>
            ))}
          </div>

          {/* Exemple */}
          <div className="gcc-guide-section">Exemple de fichier</div>
          <div className="gcc-guide-code">
            <div className="gcc-guide-code-header">
              {guide.columns.map(c => c.name).join('  ;  ')}
            </div>
            {guide.example.map((line, i) => (
              <div key={i} className="gcc-guide-code-line">
                {line.split(';').map((part, j) => (
                  <React.Fragment key={j}>
                    {j > 0 && <span className="gcc-guide-sep">;</span>}
                    <span>{part}</span>
                  </React.Fragment>
                ))}
              </div>
            ))}
            <div className="gcc-guide-code-more">⋮ (autant de points que nécessaire)</div>
          </div>

          {/* Conseils */}
          <div className="gcc-guide-tips">
            {guide.tips.map((tip, i) => (
              <div key={i} className="gcc-guide-tip">
                <span className="gcc-guide-tip-bullet" />
                {tip}
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

/* ─── Composant principal ───────────────────────────────────────────────────── */
const GeodesyCoordinateConverter = () => {
  const csrfToken = getCookie("csrftoken");

  /* ── State (LOGIQUE INCHANGÉE) ── */
  const [showUtmZoneModal, setShowUtmZoneModal] = useState(false);
  const [selectedUtmZone, setSelectedUtmZone] = useState("38");
  const [activeTab, setActiveTab]             = useState("manual");
  const [fromSystem, setFromSystem]           = useState("wgs84");
  const [toSystem, setToSystem]               = useState("laborde");
  const [fromValues, setFromValues]           = useState({});
  const [resultValues, setResultValues]       = useState({});
  const [labordeDetails, setLabordeDetails]   = useState(null);
  const [resultAdaptations, setResultAdaptations] = useState([]);
  const [selectedFile, setSelectedFile]       = useState(null);
  const [loading, setLoading]                 = useState(false);
  const [toast, setToast]                     = useState(null); // { msg, type }
  const [fileSuccess, setFileSuccess]         = useState("");   // nom du fichier téléchargé (succès batch)
  const [detailsOpen, setDetailsOpen]         = useState(true);
  const [copiedKey, setCopiedKey]             = useState(null);
  const [dragOver, setDragOver]               = useState(false);
  const [showGuide, setShowGuide]             = useState(false);
  const [calcMethod, setCalcMethod]           = useState('moindres_carres');
  const [methodsComparison, setMethodsComparison] = useState(null);
  const [activeCompareMethod, setActiveCompareMethod] = useState(null);
  const [usage, setUsage]                     = useState(null); // { plan, manual:{used,limit}, file:{used,limit}, max_lines_per_file }
  const fileInputRef = useRef(null);
  const toastTimer   = useRef(null);

  /* ── Toast : auto-dismiss succès/info (4 s), persistant pour erreur ── */
  const notify = useCallback((msg, type = 'error') => {
    clearTimeout(toastTimer.current);
    setToast({ msg, type });
    if (type === 'success' || type === 'info') {
      toastTimer.current = setTimeout(() => setToast(null), 4000);
    }
  }, []);

  const dismissToast = useCallback(() => {
    clearTimeout(toastTimer.current);
    setToast(null);
  }, []);

  /* ── Quota restant : chargé au montage, rafraîchi après chaque conversion ── */
  const fetchUsage = useCallback(async () => {
    try {
      const res = await fetchWithAuth(`${URLS_BASE}/subscriptions/usage/`, { headers: getAuthHeaders() });
      if (!res.ok) return;
      setUsage(await res.json());
    } catch {
      // Non bloquant : l'affichage du quota restant est un simple confort visuel.
    }
  }, []);

  useEffect(() => { fetchUsage(); }, [fetchUsage]);

  /* ── Reset fromValues on system change (INCHANGÉE) ── */
  useEffect(() => {
    const empty = {};
    for (const f of SYSTEM_FIELDS[fromSystem]) empty[f.name] = "";
    setFromValues(empty);
    setResultValues({});
    setLabordeDetails(null);
    setResultAdaptations([]);
    setMethodsComparison(null);
    setActiveCompareMethod(null);
    dismissToast();
  }, [fromSystem, dismissToast]);

  const handleInputChange = (name, value) => setFromValues((p) => ({ ...p, [name]: value }));

  /* ─── API : conversion manuelle (LOGIQUE INCHANGÉE) ──────────────────────── */
  const _executeManualConversion = async (dataOverride = null) => {
    const currentFromValues = dataOverride?.values || fromValues;
    const currentFromSystem = dataOverride?.fromSystem || fromSystem;
    const currentToSystem   = dataOverride?.toSystem   || toSystem;

    const fieldsToCheck = SYSTEM_FIELDS[currentFromSystem].filter(
      (f) => currentFromSystem !== "utm" || f.name !== "zone"
    );
    const allFilled = fieldsToCheck.every(
      (f) => currentFromValues[f.name] !== "" && currentFromValues[f.name] != null
    );
    if (!allFilled) { notify("Veuillez remplir tous les champs du système source."); return; }

    dismissToast(); setLoading(true); setResultValues({});
    setLabordeDetails(null); setResultAdaptations([]);
    setMethodsComparison(null); setActiveCompareMethod(null);

    try {
      const payload = {
        fromSystem: currentFromSystem,
        toSystem: currentToSystem,
        values: currentFromValues,
        method: calcMethod,
      };
      const headers = getAuthHeaders({ "Content-Type": "application/json" });
      if (csrfToken) headers["X-CSRFToken"] = csrfToken;

      const res  = await fetchWithAuth(`${URLS_BASE}/laborde/convert-coords/`, { method: "POST", headers, body: JSON.stringify(payload) });
      const data = await res.json();

      if (res.status === 403) {
        notify(data.message || data.detail || data.error || "Limite mensuelle de conversions atteinte pour votre plan.", 'quota');
        return;
      }
      if (!res.ok || data.status === "error" || data.code === "not_authenticated")
        throw new Error(data.detail || data.error || data.message || `Erreur ${res.status}`);

      setResultValues(data.result);
      if (data.details) { setLabordeDetails(data.details); setResultAdaptations(data.details.details_point); }
      if (data.methods_comparison && Object.keys(data.methods_comparison).length > 1) {
        setMethodsComparison(data.methods_comparison);
        setActiveCompareMethod(data.active_method || calcMethod);
      }
    } catch (err) {
      notify(sanitizeError(err.message, "Conversion impossible. Vérifiez le format et le système de coordonnées."));
    } finally {
      setLoading(false);
      fetchUsage();
    }
  };

  /* ─── API : conversion fichier (LOGIQUE INCHANGÉE) ───────────────────────── */
  const _executeFileConversion = async (dataOverride = null) => {
    const currentFromSystem = dataOverride?.fromSystem || fromSystem;
    const currentToSystem   = dataOverride?.toSystem   || toSystem;
    const baseName          = selectedFile.name;
    const filename          = baseName.replace(/\.[^/.]+$/, "");
    const downloadName      = `Madjeo_${filename}_converted_to_${currentToSystem}.csv`;
    if (!selectedFile) { notify("Veuillez sélectionner un fichier (CSV/TXT)."); return; }
    dismissToast(); setFileSuccess(""); setLoading(true);

    try {
      const formData = new FormData();
      formData.append("fromSystem", currentFromSystem);
      formData.append("toSystem", currentToSystem);
      formData.append("file", selectedFile);
      formData.append("downloadName", downloadName);
      if (dataOverride?.values?.zone) formData.append("utm_zone", dataOverride.values.zone);

      const headers = getAuthHeaders();
      if (csrfToken) headers["X-CSRFToken"] = csrfToken;

      const res = await fetchWithAuth(`${URLS_BASE}/laborde/convert-coords/`, { method: "POST", headers, body: formData });

      if (!res.ok) {
        const errorText = await res.text();
        let msg = `Erreur ${res.status}`;
        try { const d = JSON.parse(errorText); msg = d.detail || d.error || d.message || msg; } catch {}
        if (res.status === 403) { notify(msg, 'quota'); return; }
        throw new Error(msg);
      }

      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = Object.assign(document.createElement("a"), { href: url, download: downloadName });
      a.click();
      URL.revokeObjectURL(url);
      setFileSuccess(downloadName);
      notify(`Fichier téléchargé : ${downloadName}`, 'success');
    } catch (err) {
      notify(sanitizeError(err.message, "Traitement du fichier impossible. Vérifiez le format et le système de coordonnées."));
    } finally {
      setLoading(false);
      fetchUsage();
    }
  };

  /* ─── Wrappers (LOGIQUE INCHANGÉE) ───────────────────────────────────────── */
  const onConvertManual = () => {
    const fieldsForCheck = SYSTEM_FIELDS[fromSystem].filter((f) => fromSystem !== "utm" || f.name !== "zone");
    const allFilled = fieldsForCheck.every((f) => fromValues[f.name] !== "" && fromValues[f.name] != null);
    if (!allFilled) { notify(`Remplissez : ${fieldsForCheck.map((f) => f.label).join(", ")}`); return; }
    fromSystem === "utm" ? setShowUtmZoneModal(true) : _executeManualConversion();
  };

  const onConvertFile = () => {
    if (!selectedFile) { notify("Veuillez sélectionner un fichier (CSV/TXT)."); return; }
    fromSystem === "utm" ? setShowUtmZoneModal(true) : _executeFileConversion();
  };

  const confirmUtmZoneAndConvert = () => {
    setShowUtmZoneModal(false);
    const override = { values: { ...fromValues, zone: selectedUtmZone }, fromSystem, toSystem };
    activeTab === "manual" ? _executeManualConversion(override) : _executeFileConversion(override);
  };

  const reset = () => {
    setResultValues({}); setLabordeDetails(null); setResultAdaptations([]);
    setMethodsComparison(null); setActiveCompareMethod(null);
    dismissToast(); setFileSuccess(""); setSelectedFile(null);
    const empty = {};
    for (const f of SYSTEM_FIELDS[fromSystem]) empty[f.name] = "";
    setFromValues(empty);
  };

  /* ─── Helpers UI ─────────────────────────────────────────────────────────── */
  const formatResultValue = (key, value) => {
    if (value == null || value === "") return "";
    if (key === "zone") return String(value);
    const num = parseFloat(value);
    if (!isNaN(num)) return num.toFixed(key.includes("lat") || key.includes("lon") ? 6 : 3);
    return String(value);
  };

  const handleCopy = (key, value) => {
    navigator.clipboard?.writeText(value).then(() => {
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 1500);
    });
  };

  const handleFileDrop = (e) => {
    e.preventDefault(); setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file && (file.name.endsWith(".csv") || file.name.endsWith(".txt"))) setSelectedFile(file);
  };

  const switchCompareMethod = (mkey) => {
    const mdata = methodsComparison?.[mkey];
    if (!mdata) return;
    setResultValues(mdata.result);
    if (mdata.details) {
      setLabordeDetails(mdata.details);
      setResultAdaptations(mdata.details.details_point || {});
    }
    setActiveCompareMethod(mkey);
  };

  const hasResults          = Object.keys(resultValues).length > 0;
  const showLaborde         = (toSystem === "laborde" || fromSystem === "laborde") && labordeDetails;
  const showMethodSelector  = (fromSystem === "laborde" || toSystem === "laborde");
  const showComparison      = !!methodsComparison && Object.keys(methodsComparison).length > 1;
  const toFields     = SYSTEM_FIELDS[toSystem];
  const fromFieldsUI = SYSTEM_FIELDS[fromSystem].filter((f) => fromSystem !== "utm" || f.name !== "zone");
  const fromSysObj   = SYSTEMS.find((s) => s.key === fromSystem);
  const toSysObj     = SYSTEMS.find((s) => s.key === toSystem);

  /* ═══════════════════════════════════════════════════════════════════════════
     RENDER
  ═══════════════════════════════════════════════════════════════════════════ */
  return (
    <div className="gcc-page">

      {/* ── Page header ─────────────────────────────────────────────────────── */}
      <div className="gcc-header">
        <div className="gcc-breadcrumb">
          <span>Expert</span>
          <Icon.ArrowRight />
          <span style={{ color: "var(--c-text-secondary)" }}>Transformation Géodésique</span>
        </div>
        <div className="gcc-title-row">
          <div className="gcc-icon-badge">
            <Icon.Globe size={22} />
          </div>
          <div className="gcc-title-group">
            <h1>Conversion de Coordonnées</h1>
            <p>WGS84 · UTM · Laborde Madagascar</p>
          </div>
        </div>
      </div>

      {/* ── Toast notification ──────────────────────────────────────────────── */}
      {toast && (
        <div className={`gcc-toast gcc-toast--${toast.type}`}>
          <span className="gcc-toast-icon">
            {toast.type === 'success'
              ? <Icon.CheckCircle size={14} />
              : toast.type === 'quota'
              ? <Icon.Zap size={14} />
              : <Icon.AlertCircle size={14} />}
          </span>
          <span>
            {toast.type === 'quota' && <strong className="gcc-toast-quota-label">Quota atteint — </strong>}
            {toast.msg}
          </span>
          <button className="gcc-toast-close" onClick={dismissToast}>
            <Icon.X size={13} />
          </button>
        </div>
      )}

      {/* ── Main grid ───────────────────────────────────────────────────────── */}
      <div className="gcc-grid">

        {/* ════════════════════════════════════════════════════════════════════
            PANNEAU GAUCHE — Configuration & Saisie
        ════════════════════════════════════════════════════════════════════ */}
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

          {/* ── Sélection systèmes ────────────────────────────────────────── */}
          <div className="gcc-panel">
            <div className="gcc-panel-header">
              <div className="gcc-panel-icon primary"><Icon.Globe size={14} /></div>
              <h2 className="gcc-panel-title">Systèmes de coordonnées</h2>
            </div>
            <div className="gcc-panel-body">
              <div className="gcc-sys-row">
                <div className="gcc-sys-group">
                  <label>Source</label>
                  <select
                    className="gcc-sys-select"
                    value={fromSystem}
                    onChange={(e) => setFromSystem(e.target.value)}
                  >
                    {SYSTEMS.map((s) => (
                      <option key={s.key} value={s.key}>{s.label} — {s.sub}</option>
                    ))}
                  </select>
                </div>

                <div className="gcc-arrow" title="Vers">
                  <Icon.ArrowRight />
                </div>

                <div className="gcc-sys-group">
                  <label>Cible</label>
                  <select
                    className="gcc-sys-select"
                    value={toSystem}
                    onChange={(e) => setToSystem(e.target.value)}
                  >
                    {SYSTEMS.map((s) => (
                      <option key={s.key} value={s.key}>{s.label} — {s.sub}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Indicateur visuel du sens de conversion */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "-4px" }}>
                <span style={{
                  padding: "3px 10px",
                  borderRadius: "6px",
                  background: fromSysObj?.color + "18",
                  color: fromSysObj?.color,
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                }}>
                  {fromSysObj?.label}
                </span>
                <svg width="20" height="8" viewBox="0 0 20 8" fill="none">
                  <path d="M0 4h17M14 1l3 3-3 3" stroke="var(--c-text-muted)" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <span style={{
                  padding: "3px 10px",
                  borderRadius: "6px",
                  background: toSysObj?.color + "18",
                  color: toSysObj?.color,
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                }}>
                  {toSysObj?.label}
                </span>
              </div>
            </div>
          </div>

          {/* ── Sélecteur de méthode (si Laborde impliqué) ───────────────── */}
          {showMethodSelector && (
            <div className="gcc-panel">
              <div className="gcc-panel-header">
                <div className="gcc-panel-icon" style={{ background: "rgba(99,102,241,0.12)", color: "#818cf8" }}>
                  <Icon.Target size={14} />
                </div>
                <h2 className="gcc-panel-title">Méthode de calcul des 7 paramètres</h2>
              </div>
              <div className="gcc-panel-body" style={{ paddingTop: 12, paddingBottom: 12 }}>
                <div className="gcc-method-selector">
                  {CALC_METHODS.map((m) => (
                    <button
                      key={m.key}
                      className={`gcc-method-card ${calcMethod === m.key ? "active" : ""}`}
                      style={calcMethod === m.key ? { "--method-color": m.color } : {}}
                      onClick={() => setCalcMethod(m.key)}
                    >
                      <span className="gcc-method-icon" style={{ color: m.color }}>
                        <m.Icon />
                      </span>
                      <div className="gcc-method-text">
                        <span className="gcc-method-label">{m.label}</span>
                        <span className="gcc-method-desc">{m.description}</span>
                      </div>
                      {calcMethod === m.key && (
                        <span className="gcc-method-check">✓</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ── Mode d'entrée ─────────────────────────────────────────────── */}
          <div className="gcc-panel">
            <div className="gcc-panel-header">
              <div className="gcc-panel-icon primary"><Icon.Zap size={14} /></div>
              <h2 className="gcc-panel-title">Saisie des coordonnées</h2>
              {/* Bouton guide format — toujours visible */}
              <button
                className="gcc-guide-btn"
                onClick={() => setShowGuide(true)}
                title="Afficher le guide de format de fichier"
              >
                <Icon.Info size={13} />
                Guide format
              </button>
            </div>
            <div className="gcc-panel-body">

              {/* Tabs */}
              <div className="gcc-tabs">
                <button
                  className={`gcc-tab ${activeTab === "manual" ? "active" : ""}`}
                  onClick={() => { setActiveTab("manual"); reset(); }}
                >
                  <Icon.MapPin size={14} />
                  Saisie manuelle
                </button>
                <button
                  className={`gcc-tab ${activeTab === "file" ? "active" : ""}`}
                  onClick={() => { setActiveTab("file"); reset(); }}
                >
                  <Icon.Upload size={14} />
                  Fichier batch
                </button>
              </div>

              {/* ── Quota restant (mois courant) ─────────────────────────── */}
              {usage && (() => {
                const q = activeTab === "manual" ? usage.manual : usage.file;
                if (!q || q.limit == null) return null;
                const remaining = Math.max(0, q.limit - q.used);
                return (
                  <div className="gcc-quota-remaining">
                    <Icon.Zap size={12} />
                    <span>
                      {remaining}/{q.limit} {activeTab === "manual" ? "conversions" : "fichiers"} restant{remaining > 1 ? "s" : ""} ce mois-ci
                    </span>
                  </div>
                );
              })()}

              {/* ── Onglet Saisie Manuelle ───────────────────────────────── */}
              {activeTab === "manual" && (
                <>
                  {fromSystem === "utm" && (
                    <div className="gcc-utm-badge">
                      <Icon.Info size={14} style={{ marginTop: "1px", flexShrink: 0 }} />
                      <span>La zone UTM (38 ou 39) sera sélectionnée avant le calcul.</span>
                    </div>
                  )}

                  {fromFieldsUI.map((f) => (
                    <div className="gcc-field" key={f.name}>
                      <label>{f.label}</label>
                      <div className="gcc-input-wrap">
                        <input
                          type="text"
                          placeholder={`Entrez ${f.label}…`}
                          value={fromValues[f.name] ?? ""}
                          onChange={(e) => handleInputChange(f.name, e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && onConvertManual()}
                        />
                        {f.unit && <span className="gcc-unit">{f.unit}</span>}
                      </div>
                    </div>
                  ))}

                  <div className="gcc-actions">
                    <button className="gcc-btn-primary" onClick={onConvertManual} disabled={loading}>
                      {loading ? <span className="gcc-spinner" /> : <Icon.Zap size={14} />}
                      {loading ? "Calcul…" : "Lancer la conversion"}
                    </button>
                    <button className="gcc-btn-ghost" onClick={reset} disabled={loading} title="Réinitialiser">
                      <Icon.RotateCcw size={14} />
                    </button>
                  </div>
                </>
              )}

              {/* ── Onglet Fichier ───────────────────────────────────────── */}
              {activeTab === "file" && (
                <>
                  {fromSystem === "utm" && (
                    <div className="gcc-utm-badge">
                      <Icon.Info size={14} style={{ marginTop: "1px", flexShrink: 0 }} />
                      <span>La zone UTM (38 ou 39) sera sélectionnée avant l'envoi.</span>
                    </div>
                  )}

                  {selectedFile ? (
                    <div className="gcc-file-selected">
                      <Icon.File size={16} />
                      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {selectedFile.name}
                      </span>
                      <button
                        onClick={() => setSelectedFile(null)}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#059669", display: "flex" }}
                        title="Retirer"
                      >
                        <Icon.X size={14} />
                      </button>
                    </div>
                  ) : (
                    <div
                      className={`gcc-dropzone ${dragOver ? "dragover" : ""}`}
                      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                      onDragLeave={() => setDragOver(false)}
                      onDrop={handleFileDrop}
                    >
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".txt,.csv"
                        onChange={(e) => setSelectedFile(e.target.files[0])}
                      />
                      <div className="gcc-dropzone-icon">
                        <Icon.Upload size={18} />
                      </div>
                      <p>Glissez votre fichier ici ou <strong>cliquez pour parcourir</strong></p>
                      <p className="gcc-file-hint">Formats acceptés : CSV, TXT — séparateur recommandé : ;</p>
                    </div>
                  )}

                  <div className="gcc-actions">
                    <button
                      className="gcc-btn-primary"
                      onClick={onConvertFile}
                      disabled={loading || !selectedFile}
                    >
                      {loading ? <span className="gcc-spinner" /> : <Icon.Download size={14} />}
                      {loading ? "Traitement…" : "Envoyer & Télécharger"}
                    </button>
                    <button className="gcc-btn-ghost" onClick={reset} disabled={loading} title="Réinitialiser">
                      <Icon.RotateCcw size={14} />
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

        </div>
        {/* fin panneau gauche */}

        {/* ════════════════════════════════════════════════════════════════════
            PANNEAU DROIT — Résultats
        ════════════════════════════════════════════════════════════════════ */}
        <div className="gcc-results-stack">

          {/* ── Résultats manuelle ────────────────────────────────────────── */}
          {activeTab === "manual" && (
            <div className="gcc-panel">
              <div className="gcc-panel-header">
                <div className="gcc-panel-icon success"><Icon.CheckCircle size={14} /></div>
                <h2 className="gcc-panel-title">
                  Résultat — <span style={{ color: toSysObj?.color }}>{toSysObj?.label}</span>
                </h2>
                {hasResults && (
                  <span style={{
                    marginLeft: "auto",
                    padding: "2px 8px",
                    borderRadius: "5px",
                    background: "#d1fae5",
                    color: "#059669",
                    fontSize: "0.68rem",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                  }}>
                    CALCULÉ
                  </span>
                )}
              </div>
              <div className="gcc-panel-body">

                {/* Skeleton pendant le chargement */}
                {loading && (
                  <>
                    {toFields.map((f) => (
                      <div key={f.name} className="gcc-skeleton gcc-skeleton-field" />
                    ))}
                  </>
                )}

                {/* Résultats */}
                {!loading && hasResults && toFields.map((f, i) => {
                  const val = formatResultValue(f.name, resultValues[f.name]);
                  return (
                    <div
                      key={f.name}
                      className="gcc-result-field gcc-result-appear"
                      style={{ animationDelay: `${i * 60}ms` }}
                    >
                      <span className="gcc-result-label">{f.label}</span>
                      <div className="gcc-result-value-wrap">
                        <span className="gcc-result-value">{val || "—"}</span>
                        {f.unit && <span className="gcc-result-unit">{f.unit}</span>}
                        {val && (
                          <button
                            onClick={() => handleCopy(f.name, val)}
                            title="Copier"
                            style={{
                              background: copiedKey === f.name ? "#d1fae5" : "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "4px",
                              borderRadius: "5px",
                              color: copiedKey === f.name ? "#059669" : "var(--c-text-muted)",
                              display: "flex",
                              transition: "all 0.15s ease",
                            }}
                          >
                            {copiedKey === f.name
                              ? <Icon.CheckCircle size={13} />
                              : <Icon.Copy size={13} />}
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}

                {/* Empty state */}
                {!loading && !hasResults && (
                  <div className="gcc-empty">
                    <div className="gcc-empty-icon">
                      <Icon.MapPin size={24} />
                    </div>
                    <h4>Aucun résultat pour l'instant</h4>
                    <p>Renseignez vos coordonnées source et lancez la conversion.</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── Mode fichier ──────────────────────────────────────────────── */}
          {activeTab === "file" && (
            <div className="gcc-panel">
              <div className="gcc-panel-header">
                <div className="gcc-panel-icon info"><Icon.File size={14} /></div>
                <h2 className="gcc-panel-title">Traitement par lot</h2>
              </div>
              <div className="gcc-panel-body">
                {fileSuccess ? (
                  <div className="gcc-success-panel">
                    <div className="gcc-success-ring">
                      <Icon.CheckCircle size={28} />
                    </div>
                    <h4>Téléchargement réussi !</h4>
                    <p>{fileSuccess}</p>
                    <button
                      className="gcc-btn-ghost"
                      style={{ width: "auto", padding: "0 16px", marginTop: "8px" }}
                      onClick={reset}
                    >
                      Nouvelle conversion
                    </button>
                  </div>
                ) : (
                  <div className="gcc-file-empty">
                    <div className="gcc-empty-icon">
                      <Icon.Download size={24} />
                    </div>
                    <h4>Conversion par lot</h4>
                    <p>
                      Sélectionnez un fichier CSV ou TXT contenant vos coordonnées.
                      Le fichier converti sera téléchargé automatiquement.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── Détails Laborde (précision) ───────────────────────────────── */}
          {showLaborde && (
            <div className="gcc-details-panel gcc-result-appear">
              <div className="gcc-details-header" onClick={() => setDetailsOpen((o) => !o)}>
                <div className="gcc-details-title">
                  <div style={{ width: 24, height: 24, borderRadius: 6, background: "#fef3c7", color: "#d97706", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon.BarChart size={13} />
                  </div>
                  Précision de la transformation Laborde
                  {labordeDetails?.erreur && (
                    <span style={{ padding: "2px 7px", background: "#fef3c7", borderRadius: "5px", fontSize: "0.68rem", fontWeight: 700, color: "#92400e", letterSpacing: "0.04em" }}>
                      RMS disponible
                    </span>
                  )}
                </div>
                <span className={`gcc-details-chevron ${detailsOpen ? "open" : ""}`}>
                  <Icon.ChevronDown size={16} />
                </span>
              </div>

              {detailsOpen && (
                <div className="gcc-details-body">

                  {/* RMS cards */}
                  {labordeDetails?.erreur && (
                    <div className="gcc-rms-row">
                      <div className="gcc-rms-card">
                        <div className="gcc-rms-label">RMS ΔX</div>
                        <div className="gcc-rms-value">
                          {(labordeDetails.erreur.rms_ex ?? labordeDetails.erreur.ex ?? 0).toFixed(4)}
                          <span className="gcc-rms-unit">m</span>
                        </div>
                      </div>
                      <div className="gcc-rms-card">
                        <div className="gcc-rms-label">RMS ΔY</div>
                        <div className="gcc-rms-value">
                          {(labordeDetails.erreur.rms_ey ?? labordeDetails.erreur.ey ?? 0).toFixed(4)}
                          <span className="gcc-rms-unit">m</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Points table */}
                  {resultAdaptations && Object.keys(resultAdaptations).length > 0 && (
                    <table className="gcc-pts-table">
                      <thead>
                        <tr>
                          <th>Point</th>
                          <th>ΔX</th>
                          <th>ΔY</th>
                          <th>ΔXY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(resultAdaptations).map(([id, pt], i) => {
                          const dxy = pt.dxy ?? 0;
                          const cls = dxy > 0.1 ? "td-red" : dxy < 0 ? "td-green" : "";
                          return (
                            <tr key={id}>
                              <td style={{ fontWeight: 600 }}>{pt.nom || `Pt ${i + 1}`}</td>
                              <td className={cls}>{pt.ex?.toFixed(3) ?? "—"}</td>
                              <td className={cls}>{pt.ey?.toFixed(3) ?? "—"}</td>
                              <td className={cls} style={{ fontWeight: 700 }}>{dxy.toFixed(3)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}

                  {(!resultAdaptations || Object.keys(resultAdaptations).length === 0) && (
                    <p style={{ margin: "14px 0 0", fontSize: "0.8rem", color: "var(--c-text-muted)" }}>
                      Aucun détail par point d'adaptation disponible.
                    </p>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ── Panneau de comparaison des méthodes ────────────────────── */}
          {showComparison && activeTab === "manual" && (
            <div className="gcc-details-panel gcc-result-appear">
              <div className="gcc-details-header" style={{ cursor: "default" }}>
                <div className="gcc-details-title">
                  <div style={{ width: 24, height: 24, borderRadius: 6, background: "rgba(99,102,241,0.12)", color: "#818cf8", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon.GitCompare size={13} />
                  </div>
                  Comparer les méthodes de calcul
                  <span style={{ padding: "2px 7px", background: "rgba(99,102,241,0.12)", borderRadius: "5px", fontSize: "0.68rem", fontWeight: 700, color: "#818cf8", letterSpacing: "0.04em" }}>
                    {CALC_METHODS.find(m => m.key === activeCompareMethod)?.short || "—"}
                  </span>
                </div>
              </div>
              <div className="gcc-details-body">
                <div className="gcc-compare-grid">
                  {CALC_METHODS.map((m) => {
                    const mdata = methodsComparison[m.key];
                    const isActive = activeCompareMethod === m.key;
                    if (!mdata) return null;
                    const res = mdata.result;
                    const acc = mdata.details?.erreur;
                    const xVal = res.x != null ? parseFloat(res.x).toFixed(3) : res.latitude != null ? parseFloat(res.latitude).toFixed(6) : "—";
                    const yVal = res.y != null ? parseFloat(res.y).toFixed(3) : res.longitude != null ? parseFloat(res.longitude).toFixed(6) : "—";
                    const xLabel = res.x != null ? "X" : "Lat";
                    const yLabel = res.y != null ? "Y" : "Lon";
                    return (
                      <button
                        key={m.key}
                        className={`gcc-compare-card ${isActive ? "active" : ""}`}
                        style={isActive ? { "--cmp-color": m.color } : {}}
                        onClick={() => !isActive && switchCompareMethod(m.key)}
                        title={isActive ? "Méthode active" : `Utiliser ${m.label}`}
                      >
                        <div className="gcc-cmp-header">
                          <span className="gcc-cmp-badge" style={{ background: m.color + "22", color: m.color }}>
                            <m.Icon />{m.short}
                          </span>
                          <span className="gcc-cmp-name">{m.label}</span>
                          {isActive
                            ? <span className="gcc-cmp-active-tag">Actif</span>
                            : <span className="gcc-cmp-switch">Activer</span>}
                        </div>
                        <div className="gcc-cmp-coords">
                          <div className="gcc-cmp-coord">
                            <span className="gcc-cmp-coord-label">{xLabel}</span>
                            <span className="gcc-cmp-coord-val">{xVal}</span>
                          </div>
                          <div className="gcc-cmp-coord">
                            <span className="gcc-cmp-coord-label">{yLabel}</span>
                            <span className="gcc-cmp-coord-val">{yVal}</span>
                          </div>
                        </div>
                        {acc && (
                          <div className="gcc-cmp-acc">
                            <span>RMS ΔX <strong>{(acc.ex ?? 0).toFixed(3)}m</strong></span>
                            <span>RMS ΔY <strong>{(acc.ey ?? 0).toFixed(3)}m</strong></span>
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>
                <p className="gcc-cmp-hint">
                  Cliquez sur une méthode pour voir son résultat. Les écarts RMS indiquent la précision sur les points d'adaptation.
                </p>
              </div>
            </div>
          )}

        </div>
        {/* fin panneau droit */}

      </div>
      {/* fin gcc-grid */}

      {/* ════════════════════════════════════════════════════════════════════════
          MODAL — Sélection zone UTM
      ════════════════════════════════════════════════════════════════════════ */}
      {showUtmZoneModal && (
        <div className="gcc-modal-backdrop" onClick={() => setShowUtmZoneModal(false)}>
          <div className="gcc-modal" onClick={(e) => e.stopPropagation()}>

            <div className="gcc-modal-header">
              <div className="gcc-modal-title">
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eef0ff", color: "#667eea", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon.MapPin size={16} />
                </div>
                Zone UTM source
              </div>
              <button className="gcc-modal-close" onClick={() => setShowUtmZoneModal(false)}>
                <Icon.X size={14} />
              </button>
            </div>

            <div className="gcc-modal-body">
              <p className="gcc-modal-desc">
                Vos coordonnées sont en <strong>UTM</strong>. Sélectionnez la zone correspondant
                à Madagascar — zone <strong>38 S</strong> (côte ouest) ou <strong>39 S</strong> (côte est).
              </p>

              <div className="gcc-zone-grid">
                {["38", "39"].map((z) => (
                  <button
                    key={z}
                    className={`gcc-zone-btn ${selectedUtmZone === z ? "selected" : ""}`}
                    onClick={() => setSelectedUtmZone(z)}
                  >
                    <div className="zone-number">{z}</div>
                    <div className="zone-label">Zone {z} S</div>
                    {z === "38" && (
                      <div style={{ fontSize: "0.68rem", color: "var(--c-text-muted)", marginTop: "4px" }}>Côte Ouest</div>
                    )}
                    {z === "39" && (
                      <div style={{ fontSize: "0.68rem", color: "var(--c-text-muted)", marginTop: "4px" }}>Côte Est</div>
                    )}
                  </button>
                ))}
              </div>

              <div className="gcc-zone-indicator">
                {["38", "39"].map((z) => (
                  <div key={z} className={`gcc-zone-dot ${selectedUtmZone === z ? "active" : ""}`} />
                ))}
              </div>
            </div>

            <div className="gcc-modal-footer">
              <button className="gcc-btn-cancel" onClick={() => setShowUtmZoneModal(false)}>
                Annuler
              </button>
              <button className="gcc-btn-confirm" onClick={confirmUtmZoneAndConvert}>
                Zone {selectedUtmZone} — {activeTab === "manual" ? "Lancer" : "Télécharger"}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ── Modal guide format ────────────────────────────────────────────────── */}
      {showGuide && (
        <FormatGuideModal
          system={fromSystem}
          onClose={() => setShowGuide(false)}
        />
      )}

    </div>
  );
};

export default GeodesyCoordinateConverter;
